var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStructureIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33 19.523c-1.484 0-2.284-.8-2.284-2.296V6.938c0-1.517.793-2.317 2.297-2.317h7.3c1.498 0 2.297.807 2.297 2.317v7.404c0 .697-.246 1.039-.635 1.374-.869.793-.704 1.982.116 2.379.287.143.526.376.526.731a.68.68 0 0 1-.697.697H8.33zm-.056-4.703c.233 0 .431-.191.431-.43V6.262c0-.24-.198-.43-.43-.43a.433.433 0 0 0-.431.43v8.128c0 .239.198.43.43.43zm2.81-1.852c.308 0 .513-.158.615-.54l.322-.957h1.9l.321.957c.103.376.308.54.615.54.376 0 .609-.226.609-.574 0-.11-.02-.233-.089-.417l-1.442-4c-.165-.492-.493-.73-.971-.73-.479 0-.786.238-.957.73l-1.442 4a1.29 1.29 0 0 0-.083.417c0 .348.226.574.602.574zm1.19-2.413.67-2.106h.06l.664 2.106h-1.395zm-3.692 7.574h7c-.362-.643-.39-1.45-.048-2.18a.926.926 0 0 1-.198.02H8.63c-.745 0-1.183.458-1.183 1.073 0 .643.383 1.087 1.135 1.087z",
    fill: "#1D5AF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStructureIcon);
export default __webpack_public_path__ + "static/media/structureIcon.eb0163d58022dd7e7948d7ffdb9966fd.svg";
export { ForwardRef as ReactComponent };